<template>
	<v-app>
		<Navbar />

		<v-content>
			<router-view></router-view>
		</v-content>
		<Footer />
	</v-app>
</template>

<script>
import Navbar from "@/components/NavBar";
import Footer from "@/components/Footer";

export default {
	name: "App",
	components: {
		Footer,
		Navbar,
	},
	data: () => ({
		//
	}),
};
</script>
